import Carousel from "../../component/carousel"

const Manufacturing = ()=>{
    return(
        <>
         <Carousel
         mainText={
            `Co-Create: Elevate Your Association's Success with Tailored Events.`
         }
         smallText={
            `Unlock your association's potential with Co-Create by CIMGLOBAL. Tailored events designed to amplify your goals - from boosting membership to igniting community engagement. Let's collaborate and bring your vision to life.`
         }
         images={["img/slide-01.jpg","img/slide-01.jpg","img/slide-01.jpg"]}
         />
        <section className="mod-two-cols" data-lazy-load>

        <div className="">
        
        <div className="grid">
            <div className="grid__item md--two-thirds mod-two-cols--padded">
                <h3 className="heading-1"><span>Manufacturing</span></h3>

                <ul className="list-metrics">
                    <li>
                        <div className="metrics metrics--large metrics--base-info">
                           {/* <div className="metrics__ico">
                                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
                                    <g fill="none" fill-rule="nonzero" stroke="#4D4F53">
                                        <path d="M38.5 40.5H28.08c.275.783.42 1.63.42 2.5 0 3.572-2.44 6.5-5.5 6.5s-5.5-2.928-5.5-6.5c0-.87.145-1.717.42-2.5H7.505C7.768 57.5 21.5 71.232 38.5 71.496V59.535l.717.346c.837.403 1.79.619 2.783.619 3.056 0 5.5-2.037 5.5-4.5s-2.444-4.5-5.5-4.5c-.993 0-1.946.216-2.783.62l-.717.345V40.5zM38.5 40.5V30.08a7.53 7.53 0 0 1-2.5.42c-3.572 0-6.5-2.44-6.5-5.5s2.928-5.5 6.5-5.5c.87 0 1.717.145 2.5.42V9.505C21.5 9.768 7.768 23.5 7.504 40.5H38.5z" />
                                        <path fill="#4D4F53" fill-opacity=".16" d="M42.863 41.125l10.066 2.697a7.53 7.53 0 0 1 .24-2.524c.925-3.45 4.04-5.647 6.995-4.855 2.956.792 4.555 4.252 3.63 7.702a7.53 7.53 0 0 1-1.053 2.306l10.062 2.696c4.144-16.489-5.565-33.307-21.917-37.962L47.79 22.738l-.603-.52a6.414 6.414 0 0 0-2.528-1.318c-2.952-.79-5.84.544-6.478 2.924-.637 2.379 1.197 4.979 4.148 5.77.96.257 1.936.295 2.849.122l.782-.148-.206.769-2.89 10.788z" />
                                    </g>
                                </svg>
                            </div> */}
                            <div className="text--small md--one-whole">
                                <div className="text--bold">Your Vision, Our Expertise, Infinite Possibilities</div>
                                <div>
                                    <span className="dot"></span>
                                      <div>Transforming visions into reality with expert planning, customization, and limitless potential.</div>
                                </div>

                            </div>
                        </div>
                    </li>
                </ul>

                <div className="heading-2">
              <br/>
<h3>Maximize the potential of your association with Co-Create by CIMGLOBAL. </h3>

                </div>
                <p style={{fontSize:"20px",lineHeight:"120%",marginTop:"15px"}}>We understand the hesitations that come with event planning, including financial risk and uncertainty. Co-Create alleviates these concerns by sharing the burden and safeguarding your vision. Together, we navigate the complexities of event management, combining resources, expertise, and risk management. With us by your side, you can confidently pursue ambitious goals, knowing that we're invested in your success. 
</p>
<div className="heading-2">
               <p>Let's turn your aspirations into reality and create something extraordinary together."</p>
                </div>
            </div>
        </div>
    </div>
</section>

<article className="mod-text-media mod-text-media__scheme--Light" data-lazy-load>
    <div className="mod-text-media__wrapper grid">
        <div className="grid  lg--two-thirds md-one-whole">


<div className="grid__item     
     md--one-half">
    <div className="mod-text__media">
        <div className="media-wrapper mod-text__media">
                <div className="mod-overview__media">
                        <a className="link--zoom-image">
                            <img className="img-cover" src="/img/Conference-Bid-Support.jpg" alt="Conference Bid Support"/>  
                        </a>   
                </div>
        </div>
    </div>
</div>
            <div className="grid__item md--one-half">
                <div className="mod-text__content">
                    <h3 className="heading-3 mod-text__header mod-text-media__header">Your association can benefit from:</h3>
                    <div className="text--large mod-text-media__content">
                    <ul style={{listStyle:"disc",marginLeft:"25px",fontSize:"20px",lineHeight:"120%",marginTop:"5px"}}>
    <li><b>Collaborative Ideation Sessions:</b> We facilitate collaborative brainstorming sessions with association stakeholders to gather insights, ideas, and feedback. By involving key stakeholders in the planning process, we ensure that the event reflects the collective vision and priorities of your organization.</li>
    <li><b>Strategic Goal Alignment:</b> Co-Create ensures that every element of the event is aligned with your association's strategic objectives. Whether it's increasing membership, fostering community engagement, or advancing your mission, our team works closely with you to ensure that the event serves as a catalyst for achieving your goals.</li>
    <li><b>Customizable Event Planning:</b> Tailored event solutions designed to meet the unique needs and objectives of your association. From venue selection to program development, every aspect is meticulously crafted to align with your vision and goals.</li>
</ul>
                          
                    </div>
                       
                </div>
            </div>
        </div>
    </div>
</article>

<article className="mod-text-media mod-text-media__scheme--Light" data-lazy-load>
    <div className="mod-text-media__wrapper grid">
        <div className="grid push--lg--one-third lg--two-thirds md-one-whole">

            <div className="grid__item md--one-half">
                <div className="mod-text__content">
                    <h3 className="heading-3 mod-text__header mod-text-media__header">Benefits of Co-Create:</h3>
                    <div className="text--large mod-text-media__content">
                    <ul style={{listStyle:"disc",marginLeft:"25px",fontSize:"20px",lineHeight:"120%",marginTop:"15px"}}>
    <li><b>Time Savings:</b> Co-Create streamlines the event planning process, allowing association leaders to focus on core responsibilities while our expert team handles the intricate details.</li>
    <li><b>Stress Reduction:</b>  With CIMGLOBAL as your partner, say goodbye to event-related stress. We manage every aspect of the event with precision and care, ensuring a seamless experience from start to finish.</li>
    <li><b>Tailored Solutions:</b>  Each event is meticulously tailored to meet the unique needs and goals of your association, guaranteeing that every detail aligns with your vision and objectives.</li>
    <li><b>Strategic Alignment:</b>  Our collaborative approach ensures that every aspect of the event is strategically aligned with your association's goals, contributing to the achievement of your overarching objectives.</li>
    <li><b>Expertise and Guidance:</b>  Benefit from our extensive experience and industry expertise as we guide you through the event planning process, offering valuable insights and recommendations along the way.</li>
    <li><b>Dedicated Support:</b>  With CIMGLOBAL as your partner, you'll have access to dedicated support every step of the way. From initial planning to post-event evaluation, we're here to ensure your event is a resounding success.</li>
    <li><b>Exceptional Results:</b>  Expect nothing but exceptional results when you partner with CIMGLOBAL. Our commitment to excellence and attention to detail guarantee that your event will exceed expectations and leave a lasting impression.</li>
    <li><b>Peace of Mind:</b>  Rest easy knowing that your event is in capable hands. With CIMGLOBAL as your partner, you can trust that every aspect of the planning and execution process is being managed with care and professionalism.</li>
  
</ul>
                    </div>
                           
                </div>
            </div>


<div className="grid__item     
     md--one-half">
    <div className="mod-text__media">
        <div className="media-wrapper mod-text__media">
                <div className="mod-overview__media">
                        <a href="#" className="link--zoom-image">
                            <img className="img-cover" src="/img/Conference-Project-Management-and-Delivery.jpg" alt="Conference Project Management and Delivery"/>  
                        </a>   
                </div>
        </div>
    </div>
</div>        </div>
    </div>
</article>



{/*
<article className="mod-text mod-text--right" data-lazy-load>
    <div className="mod-text-media__wrapper">
        <div className="grid  lg--two-thirds md-one-whole">


<div className="grid__item md--one-half">
    <div className="media-wrapper mod-text__media">
            <a href="#" className="link--zoom-image">
                <img className="img-cover" src="../../media/1112/506x240-jno181101-power-suction-tool-performs-major-clean-out-in-the-north-sea-min.jpg" alt="/media/1112/506x240-jno181101-power-suction-tool-performs-major-clean-out-in-the-north-sea-min.jpg" />
            </a>
    </div>
</div>            <div className="grid__item md--one-half dot__wrapper">
                <div className="mod-text-media__content mod-text__content">
                    <h2 className="heading-3 mod-text__header mod-text-media__header">Case highlight</h2>
                    <div className="metrics metrics--large mod-text__metrics print-hidden">
                        <div className="metrics__ico">
                            <svg xmlns="http://www.w3.org/2000/svg"  width="80" height="80" viewBox="0 0 80 80">
                                <defs>
                                    <path id="a" d="M2.302 7.594A31.873 31.873 0 0 1 23.005 0a31.862 31.862 0 0 1 19.687 6.775C48.738 12.074 52.84 20.482 55 32h-8c-.667 5.333-3 10.667-7 16-.469 0-2.364-1.667-5.686-5-3.675 2.667-7.446 4-11.314 4-3 0-15-1-15-15 0-9.333 4.733-14.333 14.198-15V9L7.08 15 .952 9c.437-.489.887-.957 1.35-1.406z" />
                                </defs>
                                <g fill="none" fill-rule="evenodd">
                                    <g opacity=".16" transform="translate(17 8)">
                                        <mask id="b" fill="#fff">
                                            <use href="#a" />
                                        </mask>
                                        <use fill="#000" fill-opacity=".16" fill-rule="nonzero" href="#a" />
                                        <g fill="#4D4F53" fill-rule="nonzero" mask="url(#b)">
                                            <path d="M-17-8h80v80h-80z" />
                                        </g>
                                    </g>
                                    <path fill="#4D4F53" fill-rule="nonzero" d="M40.596 8.009c9.766.18 19.3 4.819 25.407 13.35 8.58 11.958 7.885 28.194-1.649 39.379-.386.36-.747.283-1.03.051-.258-.283-.361-.747-.078-1.005a30.458 30.458 0 0 0 7.266-19.045h-6.544c-.18 6.03-2.654 11.752-6.829 16.03-3.298 3.092-6.004 4.87-11.157 6.469-.515.103-.747-.232-.876-.593a.766.766 0 0 1 .515-.825c4.535-1.314 7.37-2.99 9.792-5.36-1.52-1.52-3.144-3.222-4.664-4.64-3.195 2.939-7.395 4.408-11.724 4.15a16.13 16.13 0 0 1-6.159-1.65 16.17 16.17 0 0 1-4.741-3.608l-4.638 4.64a22.568 22.568 0 0 0 16.517 7.164c.54.052.721.541.721 1.082v6.907c6.854-.154 13.477-2.603 18.759-7.01.31-.257.799-.206 1.03.078.258.309.233.799-.077 1.03C54.691 69.371 47.451 72 40.004 72c-.567-.026-.722-.387-.747-.876v-7.165a24.042 24.042 0 0 1-17.342-8.17c-.31-.36-.103-.773.18-1.108 1.701-1.675 3.376-3.427 5.102-5.077-3.504-4.69-4.303-11.133-1.52-16.726a16.022 16.022 0 0 1 12.858-8.814V16.9c.026-.696.284-.876.876-.902 8.375-.206 16.26 3.994 20.795 11.056.283.412-.052 1.082-.567 1.134a.724.724 0 0 1-.67-.36c-4.149-6.495-11.312-10.361-18.965-10.361v6.984c0 .644-.232.98-.747 1.005a14.396 14.396 0 0 0-12.291 8.067c-3.582 7.216-.645 15.927 6.544 19.509a14.97 14.97 0 0 0 5.747 1.495v-6.572c-4.072-.36-7.267-3.789-7.267-7.964 0-4.407 3.582-7.989 8.014-7.989 4.38 0 7.962 3.557 7.988 7.964 0 1.314-.361 2.654-.876 3.66-.155.334-.619.515-.98.334-.36-.18-.49-.67-.309-1.005a6.618 6.618 0 0 0 .722-2.964c0-3.608-2.938-6.546-6.545-6.546a6.538 6.538 0 0 0-6.545 6.546 6.496 6.496 0 0 0 6.364 6.52c.67 0 .877.465.902.98v7.01c5.077-.258 9.87-3.17 12.291-8.04 3.582-7.217.645-15.902-6.545-19.484-.36-.155-.515-.619-.335-.98.155-.335.619-.515.98-.335C55 29.58 58.247 39.218 54.305 47.104c-.696 1.392-1.469 2.552-2.448 3.634 1.391 1.572 3.066 3.144 4.586 4.665 5.386-5.773 7.602-14.2 5.025-22.267a.752.752 0 0 1 .49-.85.797.797 0 0 1 .902.386 24.62 24.62 0 0 1 1.133 6.598h6.52c-.13-5.98-2.036-11.933-5.695-17.061-9.843-13.71-28.911-16.88-42.62-7.062-.309.258-.824.207-1.056-.128-.232-.31-.129-.825.206-1.031 5.85-4.201 12.6-6.134 19.248-5.98zm-21.541 9.329l4.87 4.845c2.809-2.32 5.463-3.969 8.606-5 .361-.129.8.103.928.464.129.361-.103.8-.464.928-13.244 5.154-18.346 19.097-13.605 30.54.206.412-.129.979-.593 1.056-.309.026-.644-.154-.747-.438-4.123-9.252-1.855-19.741 4.818-26.545L18.23 18.55c-4.303 4.381-7.215 9.948-8.297 16.03-3.015 16.597 8.014 32.473 24.634 35.462.386.026.721.361.696.748a.865.865 0 0 1-.954.721C16.916 68.366 5.372 51.692 8.516 34.322a32.042 32.042 0 0 1 9.044-17.139c.516-.515 1.057-.335 1.495.155zm20.949 20.489c1.185 0 2.164.979 2.164 2.164 0 1.212-.979 2.191-2.164 2.191-1.211 0-2.19-.98-2.19-2.19 0-1.186.979-2.165 2.19-2.165z" />
                                </g>
                            </svg>
                        </div>
                        <div className="metrics__text text--small">
                            <div className="text--bold">Challenge</div>
                            <div>
                                <span className="dot"></span>
                                Downhole access
                            </div>
                        </div>
                    </div>
                    <p className="text--large">
                        Welltec performed a clean-out operation using the Well Cleaner&#174; Power Suction Tool (PST) in a one-barrier well in the Norwegian sector of the North Sea...
                    </p>
                </div>
                <a href="jno181101-power-suction-tool-performs-major-clean-out-in-the-north-sea/index.html" className="link link--pointing text--large">
                    <span className="link__text">Read case</span>
                    <span className="icon icon--middle icon--big icon-arrow-right"></span>
                </a>
            </div>
        </div>
    </div>
</article> */}
{/*
<article className="mod-text-media mod-text-media__scheme--Light" data-lazy-load>
    <div className="mod-text-media__wrapper grid">
        <div className="grid push--lg--one-third lg--two-thirds md-one-whole">

            <div className="grid__item md--one-half">
                <div className="mod-text__content">
                    <h3 className="heading-3 mod-text__header mod-text-media__header">Mechanical solutions</h3>
                    <div className="text--large mod-text-media__content">
                        <p>Our modular mechanical solutions effectively address downhole access challenges.</p>
<p>The Well Stroker<sup>®</sup> can apply up to 100,000 lb of axial force in either direction to pull a crown plug or push an obstruction below the production zone.</p>
<p>The Welltec<sup>®</sup> Puncher can quickly drill multiple uniformly-sized holes through tubulars to establish circulation or equalize pressure. </p>
                    </div>
                </div>
            </div>


<div className="grid__item     
     md--one-half">
    <div className="mod-text__media">
        <div className="media-wrapper mod-text__media">
                <div className="video">
                    <div className="video__content">
                        <button className="btn btn-play">
                            <span className="video__play_btn"></span>
                        </button>
                            <h2 className="video-plug__title text--small">
                                <span></span>
                            </h2>
                    </div>
                    <video poster="../../media/3858/video_generic_thumb_small_v2.jpg"> 
                        <source src="https://player.vimeo.com/external/355265781.hd.mp4?s=1f31c7e97bbbb7558b67203b3818ad7e57a45f48&amp;profile_id=175" type="video/mp4"/>
                    </video>
                </div>
        </div>
    </div>
</div>        </div>
    </div>
</article>

<section className="grid mod-list" id="6013" data-lazy-load>
    <div className="grid__item lg--nine-twelfths">
        <h2 className="heading-2 mod-list__header">Products and services</h2>
        <ul className="list-articles">
                <li className="list-articles__item">
                    <div className="grid grid--flex dot__wrapper">
                        <div className="grid__item mod-list__image">
                            <div className="media-wrapper">
                                    <a href="../../products-landing-page/well-cleaner/well-cleaner-power-suction-tool/index.html">
                                            <img className="img-cover" src="../../media/6128/bold_welltec_cleaner_pst_468x264.png" alt="Well Cleaner Power Suction Tool" /> 
                                    </a>
                            </div>
                        </div>
                        <a href="../../products-landing-page/well-cleaner/well-cleaner-power-suction-tool/index.html" className="grid__item mod-list__title link">
                            <h3 className="heading-4 list-articles__title">
                                <span>Well Cleaner&#xAE; Power Suction Tool</span>
                            </h3>
                        </a>
                        <div className="grid__item  mod-list__content">
                            <a className="link link--pointing list-articles__item-link" href="../../products-landing-page/well-cleaner/well-cleaner-power-suction-tool/index.html" title="">
                                <p className="text--medium list-articles__text text--dark">
                                    <span className="dot"></span>
                                    <span>Our clean-out solutions ensure access into new wells and optimized production from old wells: removing sand and debris; cleaning SSSV seats; clearing obstructions; eliminating scale deposits; accessing isolation valves.</span>
                                </p>
                                <span className="text--medium">
                                        <span className="link__text"></span>
                                    <span className="icon icon--middle icon-arrow-right"></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
                <li className="list-articles__item">
                    <div className="grid grid--flex dot__wrapper">
                        <div className="grid__item mod-list__image">
                            <div className="media-wrapper">
                                    <a href="../../products-landing-page/well-cleaner/well-cleaner-dry-environment/index.html">
                                            <img className="img-cover" src="../../media/6124/bold_welltec_dryenv_468x264.png" alt="Well Cleaner Dry Environment 468X264" /> 
                                    </a>
                            </div>
                        </div>
                        <a href="../../products-landing-page/well-cleaner/well-cleaner-dry-environment/index.html" className="grid__item mod-list__title link">
                            <h3 className="heading-4 list-articles__title">
                                <span>Well Cleaner&#xAE; Dry Environment</span>
                            </h3>
                        </a>
                        <div className="grid__item  mod-list__content">
                            <a className="link link--pointing list-articles__item-link" href="../../products-landing-page/well-cleaner/well-cleaner-dry-environment/index.html" title="">
                                <p className="text--medium list-articles__text text--dark">
                                    <span className="dot"></span>
                                    <span>The Well Cleaner Dry Environment (DE) is designed specifically for cleaning in dry environments. The auger at the tip loosens the debris and transports it into the bailer sections of the tool.</span>
                                </p>
                                <span className="text--medium">
                                        <span className="link__text"></span>
                                    <span className="icon icon--middle icon-arrow-right"></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
                <li className="list-articles__item">
                    <div className="grid grid--flex dot__wrapper">
                        <div className="grid__item mod-list__image">
                            <div className="media-wrapper">
                                    <a href="../../products-landing-page/well-cleaner/well-cleaner-downhole-jetting-tool/index.html">
                                            <img className="img-cover" src="../../media/5291/bold_welltec_cleaner_thumb_468x264.png" alt="Well Cleaner Downhole Jetting Tool Thumb -" /> 
                                    </a>
                            </div>
                        </div>
                        <a href="../../products-landing-page/well-cleaner/well-cleaner-downhole-jetting-tool/index.html" className="grid__item mod-list__title link">
                            <h3 className="heading-4 list-articles__title">
                                <span>Well Cleaner&#xAE; Downhole Jetting Tool</span>
                            </h3>
                        </a>
                        <div className="grid__item  mod-list__content">
                            <a className="link link--pointing list-articles__item-link" href="../../products-landing-page/well-cleaner/well-cleaner-downhole-jetting-tool/index.html" title="">
                                <p className="text--medium list-articles__text text--dark">
                                    <span className="dot"></span>
                                    <span>The Well Cleaner Downhole Jetting tool (DJT) is an efficient, e-line conveyed, surface-controlled method for jetting fluid downhole. Its innovative design can quickly create a large diameter hole in hydrate or wax plugs.</span>
                                </p>
                                <span className="text--medium">
                                        <span className="link__text"></span>
                                    <span className="icon icon--middle icon-arrow-right"></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
                <li className="list-articles__item">
                    <div className="grid grid--flex dot__wrapper">
                        <div className="grid__item mod-list__image">
                            <div className="media-wrapper">
                                    <a href="../../products-landing-page/well-cleaner/well-cleaner-wishbone-honer-wbh/index.html">
                                            <img className="img-cover" src="../../media/6112/bold_welltec_cleaner_wbh_468x264_noshadow.png" alt="Well Cleaner Wishbone Honer 468x264" /> 
                                    </a>
                            </div>
                        </div>
                        <a href="../../products-landing-page/well-cleaner/well-cleaner-wishbone-honer-wbh/index.html" className="grid__item mod-list__title link">
                            <h3 className="heading-4 list-articles__title">
                                <span>Well Cleaner&#xAE; Wishbone Honer (WBH)</span>
                            </h3>
                        </a>
                        <div className="grid__item  mod-list__content">
                            <a className="link link--pointing list-articles__item-link" href="../../products-landing-page/well-cleaner/well-cleaner-wishbone-honer-wbh/index.html" title="">
                                <p className="text--medium list-articles__text text--dark">
                                    <span className="dot"></span>
                                    <span>The Well Cleaner Wishbone Honer (WBH) is designed to clean deposits from tubular walls over intervals where the internal diameter changes, such as mandrels and profiles.</span>
                                </p>
                                <span className="text--medium">
                                        <span className="link__text"></span>
                                    <span className="icon icon--middle icon-arrow-right"></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
                <li className="list-articles__item">
                    <div className="grid grid--flex dot__wrapper">
                        <div className="grid__item mod-list__image">
                            <div className="media-wrapper">
                                    <a href="../../products-landing-page/well-cleaner/welltec-auger-hdr/index.html">
                                            <img className="img-cover" src="../../media/5289/bold_welltec_auger_thumb_468x264.png" alt="Welltec Auger HDR (Heavy Debris Removal) 468x264 Thumb -" /> 
                                    </a>
                            </div>
                        </div>
                        <a href="../../products-landing-page/well-cleaner/welltec-auger-hdr/index.html" className="grid__item mod-list__title link">
                            <h3 className="heading-4 list-articles__title">
                                <span>Welltec&#xAE; Auger HDR (Heavy Debris Removal) </span>
                            </h3>
                        </a>
                        <div className="grid__item  mod-list__content">
                            <a className="link link--pointing list-articles__item-link" href="../../products-landing-page/well-cleaner/welltec-auger-hdr/index.html" title="">
                                <p className="text--medium list-articles__text text--dark">
                                    <span className="dot"></span>
                                    <span>The Welltec Auger HDR (Heavy Debris Removal) combines our proven pump driven suction systems with additional lifting forces via a specially designed mechanical auger for maximum efficiency.</span>
                                </p>
                                <span className="text--medium">
                                        <span className="link__text"></span>
                                    <span className="icon icon--middle icon-arrow-right"></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
                <li className="list-articles__item">
                    <div className="grid grid--flex dot__wrapper">
                        <div className="grid__item mod-list__image">
                            <div className="media-wrapper">
                                    <a href="../../products-landing-page/well-cleaner/well-cleaner-reverse-circulating-bit/index.html">
                                            <img className="img-cover" src="../../media/6116/bold_welltec_cleaner_mudpaddle_468x264.png" alt="Well Cleaner Reverse Circulating Bit" /> 
                                    </a>
                            </div>
                        </div>
                        <a href="../../products-landing-page/well-cleaner/well-cleaner-reverse-circulating-bit/index.html" className="grid__item mod-list__title link">
                            <h3 className="heading-4 list-articles__title">
                                <span>Well Cleaner&#xAE; Reverse Circulating Bit</span>
                            </h3>
                        </a>
                        <div className="grid__item  mod-list__content">
                            <a className="link link--pointing list-articles__item-link" href="../../products-landing-page/well-cleaner/well-cleaner-reverse-circulating-bit/index.html" title="">
                                <p className="text--medium list-articles__text text--dark">
                                    <span className="dot"></span>
                                    <span>The Well Cleaner Reverse Circulating Bit (RCB) integrates a rotary bit with a suction system to provide the combined benefits of both in one tool. This design breaks through hard packed debris and recovers the cuttings into the integrated bailers.</span>
                                </p>
                                <span className="text--medium">
                                        <span className="link__text"></span>
                                    <span className="icon icon--middle icon-arrow-right"></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
                <li className="list-articles__item">
                    <div className="grid grid--flex dot__wrapper">
                        <div className="grid__item mod-list__image">
                            <div className="media-wrapper">
                                    <a href="../../products-landing-page/well-miller/well-miller-for-scale-removal/index.html">
                                            <img className="img-cover" src="../../media/5302/bold_welltec_rcb_thumb_468x264.png" alt="Well Miller for Scale Removal Thumb -" /> 
                                    </a>
                            </div>
                        </div>
                        <a href="../../products-landing-page/well-miller/well-miller-for-scale-removal/index.html" className="grid__item mod-list__title link">
                            <h3 className="heading-4 list-articles__title">
                                <span>Well Miller&#xAE; for Scale Removal</span>
                            </h3>
                        </a>
                        <div className="grid__item  mod-list__content">
                            <a className="link link--pointing list-articles__item-link" href="../../products-landing-page/well-miller/well-miller-for-scale-removal/index.html" title="">
                                <p className="text--medium list-articles__text text--dark">
                                    <span className="dot"></span>
                                    <span>The Well Miller for Scale Removal transforms the power of the Well Miller into a clean-out application for those scale deposits which can&#x2019;t be removed effectively with standard clean-out tools.</span>
                                </p>
                                <span className="text--medium">
                                        <span className="link__text"></span>
                                    <span className="icon icon--middle icon-arrow-right"></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
                <li className="list-articles__item">
                    <div className="grid grid--flex dot__wrapper">
                        <div className="grid__item mod-list__image">
                            <div className="media-wrapper">
                                    <a href="../../products-landing-page/well-miller/well-miller-with-expandable-bit/index.html">
                                            <img className="img-cover" src="../../media/5301/bold_welltec_auger_thumb_468x264.png" alt="Well Miller Expandable Bit Thumb -" /> 
                                    </a>
                            </div>
                        </div>
                        <a href="../../products-landing-page/well-miller/well-miller-with-expandable-bit/index.html" className="grid__item mod-list__title link">
                            <h3 className="heading-4 list-articles__title">
                                <span>Well Miller&#xAE; with Expandable Bit</span>
                            </h3>
                        </a>
                        <div className="grid__item  mod-list__content">
                            <a className="link link--pointing list-articles__item-link" href="../../products-landing-page/well-miller/well-miller-with-expandable-bit/index.html" title="">
                                <p className="text--medium list-articles__text text--dark">
                                    <span className="dot"></span>
                                    <span>The Well Miller with Expandable Bit for hardware milling provides operators with a better way to repair wells with mechanical obstacles. It can pass through small ID and expand to a larger OD when activated.</span>
                                </p>
                                <span className="text--medium">
                                        <span className="link__text"></span>
                                    <span className="icon icon--middle icon-arrow-right"></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
                <li className="list-articles__item">
                    <div className="grid grid--flex dot__wrapper">
                        <div className="grid__item mod-list__image">
                            <div className="media-wrapper">
                                    <a href="../../products-landing-page/well-stroker/well-stroker/index.html">
                                            <img className="img-cover" src="../../media/5304/bold_welltec_stroker_thumb_468x264.png" alt="Well Stroker Thumb -" /> 
                                    </a>
                            </div>
                        </div>
                        <a href="../../products-landing-page/well-stroker/well-stroker/index.html" className="grid__item mod-list__title link">
                            <h3 className="heading-4 list-articles__title">
                                <span>Well Stroker&#xAE;</span>
                            </h3>
                        </a>
                        <div className="grid__item  mod-list__content">
                            <a className="link link--pointing list-articles__item-link" href="../../products-landing-page/well-stroker/well-stroker/index.html" title="">
                                <p className="text--medium list-articles__text text--dark">
                                    <span className="dot"></span>
                                    <span>The Well Stroker can push or pull multiple times in the same run irrespective of the depth and deviation. It delivers up to 100,000 lbs of axial force downhole using a bi-directional hydraulic ram.</span>
                                </p>
                                <span className="text--medium">
                                        <span className="link__text"></span>
                                    <span className="icon icon--middle icon-arrow-right"></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
                <li className="list-articles__item">
                    <div className="grid grid--flex dot__wrapper">
                        <div className="grid__item mod-list__image">
                            <div className="media-wrapper">
                                    <a href="../../products-landing-page/welltec-puncher/welltec-puncher/index.html">
                                            <img className="img-cover" src="../../media/5303/bold_welltec_puncher_thumb_468x264.png" alt="Well Puncher Thumb 468x264 -" /> 
                                    </a>
                            </div>
                        </div>
                        <a href="../../products-landing-page/welltec-puncher/welltec-puncher/index.html" className="grid__item mod-list__title link">
                            <h3 className="heading-4 list-articles__title">
                                <span>Welltec&#xAE; Puncher</span>
                            </h3>
                        </a>
                        <div className="grid__item  mod-list__content">
                            <a className="link link--pointing list-articles__item-link" href="../../products-landing-page/welltec-puncher/welltec-puncher/index.html" title="">
                                <p className="text--medium list-articles__text text--dark">
                                    <span className="dot"></span>
                                    <span>Welltec Puncher - Provides an efficient, e-line conveyed, non-explosive method for equalizing pressures between tubular strings.  Available with an ultra-slim outer diameter of just 2.125&#x201D;, its innovative design is ideal for extended reach and going beyond narrow ID restrictions.</span>
                                </p>
                                <span className="text--medium">
                                        <span className="link__text"></span>
                                    <span className="icon icon--middle icon-arrow-right"></span>
                                </span>
                            </a>
                        </div>
                    </div>
                </li>
        </ul>
    </div>
</section>
*/}
<section id="modal-favorites" className="modal modal--message modal--slide-top" aria-hidden="true">
    <div className="modal__overlay" tabindex="-1" data-micromodal-close>
        <div role="dialog" aria-modal="true" aria-labelledby="modal-favorites-title" className="modal__container">
            <header className="modal__header modal__header--empty">
                <button className="modal__btn" aria-label="Close modal" data-micromodal-close>
                    <span className="icon icon-close-light" data-micromodal-close></span>
                </button>
            </header>
            <div id="modal-favorites-content" className="modal__content text--center">
                <h2 id="modal-favorites-title" className="heading-3">Favorites</h2>
                <div className="modal__text">
                    <p>You have just added an item to your favorites.</p>
<p>You can find it under favorites in the main menu.</p>
                </div>
                <div className="modal__text">
                    <span className="icon icon--big icon-fav-counter "></span>
                </div>
                <div className="modal__text--offset-top input-choice text--small">
                    <input className="input-checkbox" id="hideFavoritesModal" type="checkbox" name="hideFavoritesModal" value=""/>
                    <label for="hideFavoritesModal"> Don&#x27;t show this message again.</label>
                </div>
            </div>
            <div className="modal__footer text--center text--small">
                <p>The favorites list is stored using cookies.</p>
            </div>
        </div>
    </div>
</section>
<div class="grid mod-related mod-related--light mod-related--has-read-more" data-lazy-load>
        <div class="grid__item lg--nine-twelfths">
            <h2 class="heading-2 mod-related__header grid--flex-center">
                <span class="mod-related__header-text">Latest updates</span>
                    <a href="#" target="" rel="noopener" class="link link--pointing text--small mod-related__header-link text--bold">
                        <span class="link__text">See all news, stories and updates</span>
                        <span class="icon icon--middle icon-arrow-right"></span>
                    </a>
            </h2>
            <ul class="grid grid--flex">
                    <li class="grid__item md--one-third mod-related__item">
                        <article class="block text--small mod-related__block">
                            <a class="link link--pointing dot__wrapper mod-related__block link--zoom-image" href="#" title="Read more" rel="noopener">
                                <div class="media-wrapper block__media block__media--standard">
                                        <img class="img-cover" src="/img/istock-636032898-sea-rig.jpg" />
                                </div>
                                <div class="mod-related__link">
                                    <div class="mod-related__content">
                                        <div class="tag block__tag text--dark">
                                            07.12.2023 -
                                            Company news
                                        </div>

                                        <h3 class="text--bold text--small">
                                            <span>Court rules in favour of CIMGLOBAL to protect patents</span>
                                        </h3>

                                        <div class="block__text text--dark">
                                            <span class="dot"></span>
                                            <span>The Borgarting Court of Appeal in Norway has sided with CIMGLOBAL and ruled that Altus Intervention has infringed and misused a patent for well intervention that belongs to CIMGLOBAL Oilfield Services in Stavanger.</span>
                                        </div>
                                    </div>

                                    <span>
                                        <span class="link__text">Read more</span>
                                        <span class="icon icon--middle icon-arrow-right"></span>
                                    </span>
                                </div>
                            </a>
                        </article>
                    </li>
                    <li class="grid__item md--one-third mod-related__item">
                        <article class="block text--small mod-related__block">
                            <a class="link link--pointing dot__wrapper mod-related__block link--zoom-image" href="#" title="Read more" rel="noopener">
                                <div class="media-wrapper block__media block__media--standard">
                                        <img class="img-cover" src="/img/seo-794-x396-test-loop.jpg" />
                                </div>
                                <div class="mod-related__link">
                                    <div class="mod-related__content">
                                        <div class="tag block__tag text--dark">
                                            13.11.2023 -
                                            Company news
                                        </div>

                                        <h3 class="text--bold text--small">
                                            <span>Strategic partnership focuses on enhancing CCUS and PtX testing</span>
                                        </h3>

                                        <div class="block__text text--dark">
                                            <span class="dot"></span>
                                            <span>CIMGLOBAL and FORCE Technology will deliver cutting-edge advanced testing services for Carbon Capture, Utilisation, and Storage (CCUS) and Power-to-X (PtX) markets.</span>
                                        </div>
                                    </div>

                                    <span>
                                        <span class="link__text">Read more</span>
                                        <span class="icon icon--middle icon-arrow-right"></span>
                                    </span>
                                </div>
                            </a>
                        </article>
                    </li>
                    <li class="grid__item md--one-third mod-related__item">
                        <article class="block text--small mod-related__block">
                            <a class="link link--pointing dot__wrapper mod-related__block link--zoom-image" href="#" title="Read more" rel="noopener">
                                <div class="media-wrapper block__media block__media--standard">
                                        <img class="img-cover" src="/img/seo-794-x396-isealate.jpg" />
                                </div>
                                <div class="mod-related__link">
                                    <div class="mod-related__content">
                                        <div class="tag block__tag text--dark">
                                            01.11.2023 -
                                            Company news
                                        </div>

                                        <h3 class="text--bold text--small">
                                            <span>Isealate Springblade Patch excels during in-field testing</span>
                                        </h3>

                                        <div class="block__text text--dark">
                                            <span class="dot"></span>
                                            <span>CIMGLOBAL&#xAE; is pleased to announce the success of the first in-field test of the Isealate Springblade Patch, a unique relining and repair solution for downhole applications.</span>
                                        </div>
                                    </div>

                                    <span>
                                        <span class="link__text">Read more</span>
                                        <span class="icon icon--middle icon-arrow-right"></span>
                                    </span>
                                </div>
                            </a>
                        </article>
                    </li>
            </ul>
        </div>
    </div>
        </>
    )
}

export default Manufacturing